import React from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import './Loader.css'
import { Fade } from '@mui/material'
import CommentSkeleton from './CommentSkeleton'

const returnSwitch = (props) => {
    switch (props.name) {
        case 'comment':
            return <CommentSkeleton />
        default:
            return <CircularProgress disableShrink />
    }
}

const Loaders = (props) => {
    return (
        <>
            {props.isLoading ? (
                <>
                    <Fade in={props.isLoading} timeout={600}>
                        <div className="loadingCnt">
                            {[...Array(props.loop ? props.loop : 1)].map(
                                (data, index) => (
                                    <div
                                        className={
                                            props.name === 'home'
                                                ? 'loader'
                                                : ''
                                        }
                                        key={index}
                                    >
                                        {returnSwitch(props)}
                                    </div>
                                )
                            )}
                        </div>
                    </Fade>
                </>
            ) : (
                <></>
            )}
        </>
    )
}

export default Loaders
